/**
 * Exports a tab link that can be used seamlessly with the Tabs component.
 */
import { LinkHTMLAttributes, ReactNode } from "react";
import styles from "../tabs.module.scss";

export type TabLinkProps = LinkHTMLAttributes<HTMLAnchorElement> & {
  /**
   * The contents of the anchor.
   */
  children: ReactNode;
  /**
   * If the element is selected.
   *
   * @default "false"
   */
  selected?: boolean;
  /**
   * The link element to use.
   */
  linkElement?: React.ElementType;
};

export const TabLink = ({
  selected,
  children,
  linkElement = "a",
  ...props
}: TabLinkProps) => {
  const LinkElement = linkElement;
  return (
    <LinkElement
      className={styles.tabLink}
      {...(selected && { "data-state": "active" })}
      {...props}
    >
      {children}
    </LinkElement>
  );
};
export default TabLink;
